import { Image } from '../../../UI/Media';
import React, { useMemo } from 'react';
import clsx from 'clsx';
import { Label } from 'components/UI/Elements/Label/label';
import { Button, ContentfulBody } from 'components/UI/Elements';

export const BlackFridayHero = ({
  desktopImage,
  image,
  desktopHeight,
  mobileHeight,
  label,
  body,
  isTextRight,
  labelPadding,
  labelBg,
  button,
  desktopDisplay,
  mobileDisplay,
}) => {
  const justifyConfig = useMemo(() => {
    return clsx(
      mobileDisplay ? mobileDisplay?.text : 'justify-end',
      `md:${desktopDisplay ? desktopDisplay?.text : 'justify-center'}`
    );
  }, [desktopDisplay, mobileDisplay]);
  const heightConfig = useMemo(
    () => ({
      desktop: `${desktopHeight?.text || 300}px`,
      mobile: `${mobileHeight?.text || 200}px`,
    }),
    [desktopHeight, mobileHeight]
  );

  return (
    <div className={'relative'}>
      <div
        style={{ height: heightConfig.mobile }}
        className="hero-black-friday mobile sm:hidden flex items-center overflow-hidden w-screen"
      >
        <div className="border-t border-b h-full w-full">
          {image && (
            <Image
              objectFit="fill"
              {...image}
              height={heightConfig.mobile}
              width="100%"
            />
          )}
        </div>
      </div>
      <div
        style={{ height: heightConfig.desktop }}
        className="hero-black-friday hidden sm:flex desktop items-center overflow-hidden w-screen"
      >
        <div className="border-t border-b h-full w-full">
          {desktopImage && (
            <Image
              objectFit="fill"
              {...desktopImage}
              height={heightConfig.desktop}
              width="100%"
            />
          )}
        </div>
      </div>
      {label || body || button ? (
        <div
          className={
            'main-wrapper mx-auto absolute top-0 left-0 right-0 bottom-0'
          }
        >
          <div
            className={clsx(
              'absolute top-0 w-full md:w-1/2 h-full flex flex-col justify-end sm:justify-center md:items-center lg:items-start space-y-8 left-0 right-0',
              isTextRight?.value ? 'md:left-1/2' : 'md:right-1/2'
            )}
          >
            <div
              className={clsx(
                'p-8 space-y-6',
                'h-full flex flex-col',
                justifyConfig
              )}
            >
              {label ? (
                <div
                  style={{ background: labelBg?.hex }}
                  className={clsx('w-fit', labelPadding?.text)}
                >
                  <Label {...label} />
                </div>
              ) : null}

              {body ? (
                <div className={'text-white'}>
                  <ContentfulBody body={body} />
                </div>
              ) : null}

              {button ? <Button {...button} /> : null}
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
};
